// src/contexts/LoadingContext.jsx

import { createContext, useState, useContext, useMemo, useCallback } from 'react';
import { LoaderCircle } from 'lucide-react';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Processando...");

  const showLoading = useCallback((message = "Processando...") => {
    setLoadingMessage(message);
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const value = useMemo(() => ({ showLoading, hideLoading, isLoading }), [showLoading, hideLoading, isLoading]);

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm">
          <LoaderCircle className="h-12 w-12 animate-spin text-white" />
          <p className="mt-4 text-lg font-medium text-white">{loadingMessage}</p>
        </div>
      )}
    </LoadingContext.Provider>
  );
}

export const useLoading = () => {
  return useContext(LoadingContext);
};
